var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.056,
    height: 16.42,
    viewBox: "0 0 26.056 16.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Video_3368767",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M3.392,0H15.11A3.372,3.372,0,0,1,18.5,3.392v9.636A3.372,3.372,0,0,1,15.11,16.42H3.392A3.422,3.422,0,0,1,0,13.028V3.392A3.422,3.422,0,0,1,3.392,0ZM15.11,1.85H3.392A1.546,1.546,0,0,0,1.85,3.392v9.636A1.546,1.546,0,0,0,3.392,14.57H15.11a1.5,1.5,0,0,0,1.542-1.542V3.392A1.5,1.5,0,0,0,15.11,1.85Z",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M245.463,21.813,250.7,18.19a.943.943,0,0,1,1.465.771h0V30.755a.9.9,0,0,1-1.465.694l-5.319-3.623a.949.949,0,0,1-.385-.771h0V22.584A.848.848,0,0,1,245.463,21.813Zm1.388,1.311v3.469l3.469,2.39V20.734Z",
    transform: "translate(-226.113 -16.648)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M85.859,58.632l-2.467-1.619-2.236-1.542a.884.884,0,0,0-.771-.077.81.81,0,0,0-.385.694v6.4a.786.786,0,0,0,.385.617.584.584,0,0,0,.771-.077l2.236-1.465,2.467-1.7a.626.626,0,0,0,.308-.617A.7.7,0,0,0,85.859,58.632Z",
    transform: "translate(-73.833 -51.077)",
    fill: "#05cb24",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.461f9888ddcc172ba1254264afada74e.svg";
export { ForwardRef as ReactComponent };